import React from 'react';
import { ErrorFallback } from './error-fallback';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { has_error: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { has_error: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
  }

  render() {
    if (this.state.has_error) {
      return (
        <ErrorFallback
          className={this.props.className}
          error={this.state.error}
          info={this.state.info}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
